module.exports = __webpack_public_path__ + "static/media/Histogram-of-Workouts.5400fb54.png";